/** Refresh this long before the access token's exp so a request never carries an expired token. */
export const REFRESH_LEAD_MS = 60_000;

/** Delay until the proactive refresh, or null when the access token's expiry is unknown. */
export function refreshDelayMs(accessTokenExpiryMs: number | null, nowMs: number): number | null {
	if (accessTokenExpiryMs === null) return null;
	return Math.max(0, accessTokenExpiryMs - REFRESH_LEAD_MS - nowMs);
}

/** Delay until the session ends, or null when sessionExpiresAt is missing or unparseable. */
export function sessionEndDelayMs(sessionExpiresAt: string | null | undefined, nowMs: number): number | null {
	if (!sessionExpiresAt) return null;
	const endMs = Date.parse(sessionExpiresAt);
	if (Number.isNaN(endMs)) return null;
	return Math.max(0, endMs - nowMs);
}
